import defaultWesbsite from './defaultWebsiteScript';

const HREF = window.location.href;
const PATH = window.location.pathname;

(function(){


    //Check Admin Route
    if(HREF.includes('/admin')){

        //Main Menu
        let mainMenu = ['contract', 'booking', 'settings'];

        //Set Indicate Path
        let pathSplit = PATH.split('/').filter((value) => value !== '');

        //Limit Width for Admin Backoffice
        const LIMITWIDTHBACKOFFICE = 1180;

        //Get Width
        let screenWidth = window.screen.width;

        //Resize
        window.addEventListener('resize', function(e){

            //Get Width value
            let outertwidth = e.target.outerWidth;
            
            //Check Width
            defaultWesbsite.checkWidth(outertwidth, LIMITWIDTHBACKOFFICE);
            
        });

        //Content Loaded
        window.addEventListener('DOMContentLoaded', function(){

            //Set Conditional for hide Backoffice Module Content
            defaultWesbsite.checkWidth(screenWidth, LIMITWIDTHBACKOFFICE);

            //Get Children from Menu
            let menuElement = [...document.getElementById('menu').children];

            //Get Current Menu Item
            let menuItem = pathSplit.find((value) => mainMenu.includes(value));

            //Check Home Page
            if(pathSplit.length === 1 && pathSplit[0] === 'admin'){

                //Check Width
                if(screenWidth > LIMITWIDTHBACKOFFICE){

                    menuElement[0].classList.add('active');

                }
                
                return;

            }
            
            //Add active Class
            menuElement.forEach((value) => {

                if(value.getAttribute('data-indicate') === menuItem){

                    //Set class
                    value.classList.add('active');

                }

            });

        });

        //Get click from menu item
        if(screenWidth <= LIMITWIDTHBACKOFFICE){

            document.addEventListener("click", function (event) {

                //Set Conditional
                defaultWesbsite.primarySidebarConditional(event);

            });

        }

        //Only for Cofirm Email Button
        if(document.getElementById('confirmmailbtn')){

            document.addEventListener('click', function(e){

                if(e.target.getAttribute('id') === 'confirmmailbtn'){

                    defaultWesbsite.checkEmail(
                        e.target.getAttribute('data-email'),
                        e.target.getAttribute('data-confirmurl'),
                        document.querySelector('meta[name="csrf-token"]').content,
                        e.target
                    );

                }

            });

        }

    }


})();